export const DONOT_SELL_SHARE_SECTION_CODE = {
  DONOT_SELL_FETCH_SECTION_CODE: 'permission-to-sell-data-ccpa',
  DONOT_SHARE_FETCH_SECTION_CODE: 'allow-targeted-advertising',
  DONOT_SELL_SUBMIT_SECTION_CODE: 'PERMISSION_TO_SELL_DATA_CCPA',
  DONOT_SHARE_SUBMIT_SECTION_CODE: 'ALLOW_TARGETED_ADVERTISING',
  DONOT_SELL_SHARE_OPTIN_VALUE: 'Y',
};

export const PRIVACY_RIGHTS_API_ENDPOINT = {
  AUTH_SUBMIT_ENDPOINT: '/mi/v1/legal/submitAuthCpra',
  UNAUTH_SUBMIT_ENDPOINT: '/mi/v1/legal/submitUnAuthCpra',
};
